var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/library/modules/_core.js
// module id = 38
// module chunks = 48 49 50